<template>
  <el-form-item :label="label" class="struct-form-item">
    <div class="form-item-content--bg list">
      <div class="struct-item list-header">
        <div class="struct-left">{{ $t('Product.paramName') }}</div>
        <div class="struct-right">{{ $t('Common.operation') }}</div>
      </div>
      <div class="struct-item list-item" v-for="(json, index) in jsonArr" :key="index">
        <div class="struct-left">{{ json.name }}</div>
        <div class="struct-right">
          <hl-button type="text" @click="handleJsonEdit(json, index)">{{
            $t('Common.edit')
          }}</hl-button>
          <hl-button type="text" @click="handleJsonDel(index)">{{ $t('Common.delete') }}</hl-button>
        </div>
      </div>
      <div class="add-btn" @click="handnleJsonAdd">
        <svg class="icon">
          <use xlink:href="#icon-add"></use>
        </svg>
        <span>{{ $t('Product.addParam') }}</span>
      </div>
    </div>
    <JsonParamsFormDialog
      v-if="jsonVisible"
      :visible.sync="jsonVisible"
      v-model="currJson"
      :needComplexDatatype="needComplexDatatype"
      @save="handleJsonSave"
    />
  </el-form-item>
</template>

<script>
import JsonParamsFormDialog from './JsonParamsFormDialog'
export default {
  model: {
    prop: 'form',
    event: 'change'
  },
  props: {
    form: {
      type: Object
    },
    label: {
      type: String,
      default: ''
    },
    needComplexDatatype: {
      type: Boolean,
      default: true
    },
    jsonProps: {
      type: String
    }
  },
  components: {
    JsonParamsFormDialog
  },
  data() {
    return {
      jsonVisible: false,
      currJson: {
        specs: {
          enumDesc: { 0: '', 1: '' },
          enumDescArr: [{ key: undefined, value: '' }]
        }
      },
      currJsonIndex: -1
    }
  },
  computed: {
    jsonArr() {
      if (!this.jsonProps) {
        return this.form.specs.item
      }
      return this.form[this.jsonProps]
    }
  },
  methods: {
    handnleJsonAdd() {
      this.currJson = {
        specs: {
          enumDesc: { 0: '', 1: '' },
          enumDescArr: [{ key: undefined, value: '' }]
        }
      }
      this.currJsonIndex = -1
      this.jsonVisible = true
    },
    handleJsonEdit(json, index) {
      this.currJson = json
      this.currJsonIndex = index
      this.jsonVisible = true
    },
    handleJsonDel(index) {
      if (!this.jsonProps) {
        this.form.specs.item.splice(index, 1)
      } else {
        this.form[this.jsonProps].splice(index, 1)
      }
    },
    handleJsonSave(json) {
      if (!this.jsonProps) {
        this.form.specs.item = this.form.specs.item || []
        if (this.currJsonIndex === -1) {
          // 新增
          this.form.specs.item.push(json)
        } else {
          this.form.specs.item.splice(this.currJsonIndex, 1, json)
        }
      } else {
        if (this.currJsonIndex === -1) {
          // 新增
          this.form[this.jsonProps].push(json)
        } else {
          this.form[this.jsonProps].splice(this.currJsonIndex, 1, json)
        }
      }
      this.jsonVisible = false
    }
  }
}
</script>

<style lang="scss" scoped>
.list {
  .list-header {
    display: flex;
    color: #333333;
  }
  .list-item {
    display: flex;
  }
}
.form-item-content--bg {
  width: 580px;
  padding: 16px;
  background: #f4f8fe;
  border-radius: 0px 16px 16px 16px;
}
.struct-form-item {
  .list {
    padding-right: 40px;
  }
  .add-btn {
    width: 100%;
    margin-top: 16px;
    line-height: 1;
    text-align: center;
    padding: 6px 0;
    border: 2px dashed rgba(218, 223, 230, 1);
    border-radius: 4px;
    font-size: 14px;
    color: $--color-blue;
    cursor: pointer;
    .icon {
      margin-right: 1px;
    }
  }
  .struct-item {
    padding-left: 25px;
    &.list-item {
      background-color: #fff;
      margin-bottom: 4px;
      height: 40px;
      line-height: 40px;
    }
    .struct-left {
      width: 360px;
    }
    .struct-right {
      width: 160px;
    }
  }
}
</style>
